import { render, staticRenderFns } from "./updateBusiness.vue?vue&type=template&id=6b42be79&"
import script from "./updateBusiness.vue?vue&type=script&lang=js&"
export * from "./updateBusiness.vue?vue&type=script&lang=js&"
import style0 from "./updateBusiness.vue?vue&type=style&index=0&id=6b42be79&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports